import React from 'react';
import {usePaymentPaypalContext} from '../../contexts/PaymentPaypalContext';
import InputCurrency from '../InputCurrency';

const FieldCurrencyPaypal = () => {
  const {currencyOptions} = usePaymentPaypalContext();

  return <InputCurrency currencyOptions={currencyOptions}/>
};

export default FieldCurrencyPaypal;
